<template>
  <h3>SCIM Authentication</h3>
  <h4>OAuth 2.0 Bearer Tokens</h4>
  <ul class="scim-tokens">
    <li v-for="token in activeOrRecentlyDeactivatedScimTokens" :key="token.id">
      <scim-bearer-token-card :token="token"/>
    </li>
  </ul>
  <atom-button label="Generate new token" type="primary" :disabled="!canCreateNewToken" @click="generateNewToken"/>
</template>

<script lang="ts">
import ScimBearerTokenCard from "authentication/components/scim/ScimBearerTokenCard.vue";
import { useScimStore } from "authentication/stores/scim-tokens.store";
import AtomButton from "core/components/atom/button/AtomButton.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: { ScimBearerTokenCard, AtomButton },
  setup() {
    return {
      scimStore: useScimStore(),
    };
  },
  computed: {
    activeOrRecentlyDeactivatedScimTokens() {
      return this.scimStore.scimTokens;
    },
    canCreateNewToken(): boolean {
      return this.scimStore.canCreateNewToken;
    },
  },
  methods: {
    async generateNewToken() {
      await this.scimStore.generateNewToken();
    },
  },
});
</script>

<style scoped lang="scss">
.scim-tokens {
  list-style-type: none;
  padding-left: 0;
}
</style>
